import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	customerSelectionTableHeading: {
		id: 'fastshift.customer-selection.customer-selection-table.heading',
		defaultMessage: 'Your customers',
		description: 'Heading for the customer selection table',
	},
	searchAriaLabel: {
		id: 'fastshift.customer-selection.customer-selection-table.search-aria-label',
		defaultMessage: 'Search by Customer, Customer domain',
		description: 'Aria label for the search input in the customer selection table',
	},
	tableCaption: {
		id: 'fastshift.customer-selection.customer-selection-table.table-caption',
		defaultMessage: 'A list of customers',
		description: 'Caption for the customer selection table',
	},
	customerColumnTitle: {
		id: 'fastshift.customer-selection.domain-selection-table.customer-column-title',
		defaultMessage: 'Customer',
		description: 'Column title for customer name in domain selection table',
	},
	customerDomainColumnTitle: {
		id: 'fastshift.customer-selection.domain-selection-table.customer-domain-column-title',
		defaultMessage: 'Customer domain',
		description: 'Column title for customer domain in domain selection table',
	},
	actionsColumnTitle: {
		id: 'fastshift.customer-selection.domain-selection-table.actions-column-title',
		defaultMessage: 'Actions',
		description: 'Column title for actions in domain selection table',
	},
	seeDetailsButton: {
		id: 'fastshift.customer-selection.domain-selection-table.see-details-button',
		defaultMessage: 'View details',
		description: 'Button text for viewing customer details',
	},
	summaryText: {
		id: 'fastshift.customer-selection.domain-selection-table.summary-text',
		defaultMessage: 'Showing {viewSize} out of {totalNumber} customers',
		description: 'Summary text for domain selection table',
	},
	errorMessage: {
		id: 'fastshift.customer-selection.domain-selection-table.error-message',
		defaultMessage: 'We’re unable to retrieve the data about your customers.',
		description: 'Error message for domain selection table',
	},
});
